import { user } from '@app/models/user';
import { userContactDetails } from '@app/pcs/models';
import {gql} from 'apollo-angular';

export const userQuery = gql`
    query User {
        user {
            ...user
        }
    }
    ${user}
`;

export const usersForAgencyResult = 'usersForAgency';
export const usersForAgencyQuery = gql`
    query UsersForAgency ($agencyId: Long!) {
        usersForAgency(agencyId: $agencyId) {
            ...userContactDetails
        }
    }
    ${userContactDetails}
`;
